import React, { Fragment } from 'react';
import _ from 'lodash';

import { gql } from '@nerdwallet/apollo';
import StructuredContent from '@nerdwallet/structured-content';

/**
 * Construct a WPHublinks structured content doc from an ID.
 *
 * @param {Number} id  Article ID.
 *
 * @return {Object} WP HubsLink structured content doc.
 */
const buildStructuredContentDoc = (id: number) => ({
  type: 'Container',
  version: '1.0.0',
  props: {
    spacing: {
      top: 3,
      bottom: 3,
    },
    children: [
      {
        type: 'WPHubLinks',
        version: '1.0.0',
        props: {
          id,
        },
      },
    ],
  },
});

interface Props {
  id: string;
}

const Hublinks: React.GraphqlFC<Props> = ({ id }) => {
  if (!id || _.isNaN(id)) {
    return null;
  }

  return (
    <Fragment>
      <StructuredContent>
        {buildStructuredContentDoc(parseInt(id, 10))}
      </StructuredContent>
    </Fragment>
  );
};

Hublinks.fragment = gql`
  fragment hubLinks on Article {
    hubLinks {
      title
      url
    }
  }
`;

export default Hublinks;
